<sm-title-bar pageTitle="{{ 'feedback.title' | translate }}" [backWithParams]="true"> </sm-title-bar>
<ng-container *ngIf="!loader && feedbackList.length>0">
    <mat-card appearance="outlined" class="subscription-info">
      <mat-card-content>
        <div class="row">
          <div class="col-12">
            <div class="info">
               <div class="fr_section_ppt">
                  <div class="out_rrm">
                    <h2>{{feedbackList[0]?.average_rating ? feedbackList[0]?.average_rating.toFixed(1) : '0'}}</h2>
                  </div>
                  <div class="out_of_ll">
                      <p>Out of <br> 5 star</p>
                  </div>
                  <div class="star_list_op">
                      <mat-icon>star</mat-icon>
                      <mat-icon>star</mat-icon>
                      <mat-icon>star</mat-icon>
                      <mat-icon>star</mat-icon>
                      <mat-icon>star</mat-icon>
                  </div>
               </div>
            </div>
          </div>
          <div class="col-12">
            <div class="info" style="position: relative;bottom: 7px;">
              <h4>{{ 'feedback.total_reviews' | translate }}:</h4>
              <p>{{feedbackList[0].rating_count}}</p>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    </ng-container>
<!-- <ng-container *ngIf="!loader && feedbackList.length==0">
    <mat-card class="subscription-info" style="padding-top: 2px;">
      <mat-card-content>
        <div class="row row-cols-md-2 row-cols-1 g-3">
          <div class="col p-md-6">
            
            <div class="info" style="padding-top: 14px;">
              <div class="fr_section_ppt">
                 <div class="out_rrm">
                   <h2>0.0</h2>
                 </div>
                 <div class="out_of_ll">
                     <p>Out of <br> 5 star</p>
                 </div>
                 <div class="star_list_op placeholderttt">
                     <mat-icon>star</mat-icon>
                     <mat-icon>star</mat-icon>
                     <mat-icon>star</mat-icon>
                     <mat-icon>star</mat-icon>
                     <mat-icon>star</mat-icon>
                 </div>
              </div>
           </div>
          </div>
          <div class="col p-md-6">
            <div class="info" style="position: relative;bottom: 0px;">
              <h4>{{ 'feedback.total_reviews' | translate }}:</h4>
              <p>0</p>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    </ng-container> -->

    <div
    *ngIf="!loader && feedbackList.length>0">

    <div class="row" >
      <div class="col-sm-4" *ngFor="let item of feedbackList">
        <mat-card appearance="outlined">
        <div class="fl_orders">
       
          <div class="top_section_order">
            <div class="row">
              <div class="col-1">
                <div class="ads_sec">
                  <div
                    class="hm_icon_progr"
                    *ngIf="item.imageThumbUrl && item.imageThumbUrl != 'null'">
                    <img [src]="item.imageThumbUrl" />
                  </div>
                  <div
                    class="hm_icon_progr"
                    *ngIf="
                      !item.imageThumbUrl ||
                      item.imageThumbUrl == 'null'
                    "
                  >
                    <img src="../../../../assets/images/photo.png" />
                  </div>
                </div>
              </div>
              <div class="col" style="padding-left: 22px">
                <div class="order_dec">
                  <h3
                    style="
                      -webkit-box-orient: vertical;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: normal;
                      margin-bottom: 2px;
                    "
                  >
                  {{item.customerName && item.customerName != 'null' ? item.customerName: 'Unknown Customer'}}
                  </h3>
                  <div class="tick_opklads">
                    {{item.creationDate | date}}
                  </div>
               
                </div>
              </div>
              <div class="newr_secty">
             
                <p *ngIf="item.rate == 1">
                  <mat-icon>star</mat-icon>
                </p>
                <p *ngIf="item.rate == 2">
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                </p>
                <p *ngIf="item.rate == 3">
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                </p>
                <p *ngIf="item.rate == 4">
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                </p>
                <p *ngIf="item.rate == 5">
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                  <mat-icon>star</mat-icon>
                </p>
                <p class="message_ttr">
                  {{item.message}}
                </p>
              </div>
            </div>
          </div>
     
        </div>
      </mat-card>
      </div>
    </div>
    <!-- <div class="row" *ngIf="messageLIst.length == 0">
      <div class="col-sm-12" >
        <div style="padding: 20px 18px 20px 18px;
        background: var(--color-primary-contrast);
        border-radius: var(--dra-radius-x-small);
        cursor: pointer;
        transition: 0.3s;">
          <div class="top_section_order">
            <div class="row">
              <div style="text-align: center;min-height: 200px;
              padding-top: 80px;">
                <p style="color: var(--color-primary-light);">No notifications to show</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

</div>
<mat-paginator
*ngIf="!loader && feedbackList.length>0"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>



<!-- placeholder html start -->

<div class="placeholder_started" *ngIf="!loader && feedbackList.length == 0">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined" style="padding-top: 10px;">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSleQ5Xtel5LkkrwODGYo0IrEcLHfT72sD8LQ&s">
                 </div>
                 <mat-card-title>No data found</mat-card-title>
                 <mat-card-content>It looks like we haven't received any feedback yet. Your insights are valuable to us! Help us enhance our services by sharing your experience.
                </mat-card-content>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined" style="padding-top: 10px;">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in creating a new business or if there's any 
                  issue with subscription, <a href="" class="cont_hedaa" (click)="opencontact()"> contact our support team.</a> 
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       Contact support 
                    </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div>  

  <!-- placeholder html end -->